import { createStyles } from '@mantine/core';

type MarketIconStylesParams = {
  size: number;
};

export const useStyles = createStyles((_, { size }: MarketIconStylesParams) => ({
  icon: {
    width: size,
    height: size,
    flexShrink: 0,
    objectFit: 'contain',
  },

  mirrored: {
    transform: 'scaleX(-1)',
  },
}));
